import { useMemo } from 'react';
import { ENABLE_ROLLOUT_CRM_NEW_FEATURE, GRAB_CRM_MOBILE_COOKIE_TOKEN_AUTH } from 'src/constants/common';
import { setMobileCookieTokenAuthEnabled } from '@utils/loginHelper';
import jsBridge from 'src/utils/jsBridge';
import useGrabXVariable from './useGrabXVariable';

const useMobileCookieTokenAuth = () => {
  const isMobileWebView = jsBridge.canUseBridge();
  const appVariant = jsBridge.getAppVariant();
  const appVersionFacet = jsBridge.getAppVersionFacet();
  const facets = useMemo(
    () => ({
      fea: GRAB_CRM_MOBILE_COOKIE_TOKEN_AUTH,
      stage: appVariant === 'gea' ? 'beta' : undefined,
      ...(appVersionFacet ? { dvc: appVersionFacet } : {}),
    }),
    [appVariant, appVersionFacet],
  );

  const { data: enableRollout, isReady: isGrabxReady } = useGrabXVariable<boolean>(
    ENABLE_ROLLOUT_CRM_NEW_FEATURE,
    facets,
    isMobileWebView,
  );

  const isReady = !isMobileWebView || isGrabxReady;
  const enableMobileCookieTokenAuth = isMobileWebView && isGrabxReady && Boolean(enableRollout);

  if (isReady) {
    setMobileCookieTokenAuthEnabled(enableMobileCookieTokenAuth);
  }

  return useMemo(
    () => ({
      enableMobileCookieTokenAuth,
      isReady,
    }),
    [enableMobileCookieTokenAuth, isReady],
  );
};

export default useMobileCookieTokenAuth;
